import React, { useCallback } from 'react';
import { TerritoryBox } from '@debank/territory-box';

import { FeedArticle } from '@/views/Stream';
import { invalidStreamList, invalidArticleDetail } from '@/views/Stream/hooks';
import { useCurrentAddressInfo, useTheme, useDeviceTypeIsMobile } from '@/hooks';
import { AspectRatio } from 'react-aspect-ratio';
import { AuthHeader } from './AuthHeader';
import { Template_Src } from './const';
import styles from './index.module.scss';
import 'react-aspect-ratio/aspect-ratio.css';

const defaultAspectRatio = 1.95;

export const ThirdPartyAppCard = ({ article }: { article: FeedArticle }) => {
  const template = article.template!;
  const { aspectRatio, url } = Template_Src[template.id] || {};

  const { address } = useCurrentAddressInfo();
  const { isDark } = useTheme();
  const isMobile = useDeviceTypeIsMobile();

  const handleAuth = useCallback(() => {
    invalidStreamList(address!);
    invalidArticleDetail(article.id, address);
  }, [article.id, address]);

  const handleUpdate = useCallback(() => {}, []);

  return template?.url ? (
    <div className={styles.container}>
      <AuthHeader articleId={article?.id} template={template} onSuccess={handleAuth} />
      <AspectRatio ratio={template.aspect_ratio || aspectRatio || defaultAspectRatio}>
        <TerritoryBox
          id={`${article.id}-${template.id}`}
          src={url || template?.url}
          user={template.user}
          data={template.data}
          isDark={isDark}
          isMobile={isMobile}
          // 用户端 article 更新时间（页面久置后，重新 focus 时，会再获取一遍 article，这时候会更新此值）
          // 第三方 可以根据它再更新一遍内部视图
          clientUpdatedAt={article.updateAt}
          // 第三方自己调用，需要控制它的调用频率，会触发 templateKey + 1
          onUpdate={handleUpdate}
        />
      </AspectRatio>
    </div>
  ) : null;
};
